import { render } from "./DiscountTag.vue?vue&type=template&id=576bff9e&lang=pug"
import script from "./DiscountTag.vue?vue&type=script&lang=js"
export * from "./DiscountTag.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__